<div
    class="song-lyrics-panel-shell"
    [class.resizing]="resizing"
    [style.--song-lyrics-panel-width]="width + 'px'">
    <div
        class="song-lyrics-resize-handle"
        [class.dragging]="resizing"
        role="separator"
        tabindex="0"
        aria-label="Resize lyrics panel"
        aria-orientation="vertical"
        [attr.aria-valuemin]="minWidth"
        [attr.aria-valuemax]="maxWidth"
        [attr.aria-valuenow]="width"
        (pointerdown)="onResizePointerDown($event)"
        (pointermove)="onResizePointerMove($event)"
        (pointerup)="onResizePointerUp($event)"
        (pointercancel)="onResizePointerCancel()"
        (keydown)="onResizeKeydown($event)"></div>

    <aside
        id="song-lyrics-panel"
        class="song-lyrics-drawer"
        [attr.aria-label]="'Lyrics for ' + (song?.title || 'current song')">
        <header class="lyrics-header">
            <div class="lyrics-heading">
                <h2>Lyrics</h2>
                <div class="song-title">{{ song?.title }}</div>
            </div>
            <button
                type="button"
                aria-label="Close lyrics panel"
                (click)="closePanel()">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M6 6l12 12M18 6L6 18" />
                </svg>
            </button>
        </header>

        <div class="lyrics-content" *ngIf="hasLyrics; else emptyLyrics">
            <pre>{{ song?.lyrics }}</pre>
        </div>

        <ng-template #emptyLyrics>
            <div class="lyrics-empty">
                <img
                    src="assets/img/player/lyrics.svg"
                    alt=""
                    aria-hidden="true" />
                <div>No lyrics for this song</div>
            </div>
        </ng-template>
    </aside>
</div>
